import { z } from 'zod'
import { uuid } from './primitives.ts'

/** M25-L (docs/M25.md C, ADR-132): the club's correction of an area's LINE OF PLAY. The line is derived on the device from the course tree
 *  (apps/web/src/data/playLine.ts); where it is wrong or missing, the direction says it here. The schema mirrors `core.command_type.payload_schema` in
 *  `20261229100100_play_bearing.sql`; the contract check (ops/contracts/check.mjs) runs the same fixtures and random payloads through both.
 *  - `area.set_play_bearing@1` is an office INTENT under `area.edit` (no projector, sendAndWait). `bearing_deg` is a whole number of degrees from true north
 *    (0…359), the direction the play travels into the area; `null` goes back to the computed line. The same values as the row in force are silent.
 *    The bearing turns a drawing and nothing else (rule 5). */
export const PLAY_BEARING_NOTE_MAX = 200

export const areaSetPlayBearingV1 = z.strictObject({
  id: uuid, area_id: uuid, bearing_deg: z.number().int().min(0).max(359).nullable(), note: z.string().max(PLAY_BEARING_NOTE_MAX).nullable().optional(),
})

export type AreaSetPlayBearingV1 = z.infer<typeof areaSetPlayBearingV1>
